<ng-container *nzStringTemplateOutlet="uiSideDrawer">
  <div [innerHTML]="uiSideDrawer"></div>
</ng-container>
